(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/analyze/assets/analyze.js') >= 0) return;  svs.modules.push('/components/sportinfo/analyze/assets/analyze.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useFetchAnalysesByDraw = svs.components.sportinfo.gameAnalysesRedux.hooks.useFetchAnalysesByDraw;
const DrawAnalyses = svs.component.analyze.DrawAnalyses;
const selectDrawAnalysesShouldShowSkeleton = svs.components.sportinfo.gameAnalysesRedux.selectors.selectDrawAnalysesShouldShowSkeleton;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;
const Analyze = _ref => {
  let branding = _ref.branding,
    className = _ref.className,
    productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    setCoupon = _ref.setCoupon,
    _ref$eventTypeId = _ref.eventTypeId,
    eventTypeId = _ref$eventTypeId === void 0 ? 1 : _ref$eventTypeId,
    _ref$sportType = _ref.sportType,
    sportType = _ref$sportType === void 0 ? 1 : _ref$sportType;
  useFetchAnalysesByDraw(drawNumber, productId);
  const shouldShowSkeleton = useSelector(state => selectDrawAnalysesShouldShowSkeleton(state, productId, drawNumber));
  if (shouldShowSkeleton) {
    return 'Hämtar spelanalyser...';
  }
  return React.createElement(ErrorBoundary, null, React.createElement("div", {
    className: className
  }, React.createElement(DrawAnalyses, {
    branding: branding,
    drawId: "".concat(productId, "_").concat(drawNumber),
    drawNumber: drawNumber,
    eventTypeId: eventTypeId,
    productId: productId,
    setCoupon: setCoupon,
    sportType: sportType
  })));
};
setGlobal('svs.components.sportinfo.analyze.Analyze', Analyze);

 })(window);